import type { CSSProperties } from 'react';

// Shared typed-node visuals. On a neutral canvas, colour is what carries
// meaning, so the hue per type is a single source consumed by the node cards
// (BaseNode), the minimap, and the add-node tiles — no drifting copies.

export const NODE_HUE: Record<string, string> = {
  customer: '#F97316',
  job: '#3B82F6',
  challenge: '#EF4444',
  opportunity: '#22C55E',
  capability: '#8B5CF6',
  assumption: '#EAB308',
  idea: '#EC4899',
  market_signal: '#0D9488',
};

export const NODE_LABEL: Record<string, string> = {
  customer: 'Customer',
  job: 'Job',
  challenge: 'Challenge',
  opportunity: 'Opportunity',
  capability: 'Capability',
  assumption: 'Assumption',
  idea: 'Idea',
  market_signal: 'Market finding',
};

// Soft tinted surface derived from a node hue (mirrors Badge's soft variant).
// Shared by the respondent draft items, the assumption board's stickies, the
// affinity board's cluster frames, and anything else needing a type-coloured
// surface. Defaults are the original sticky values, so existing callers are
// unaffected; the affinity board passes a lighter mix on a darker ground to sit
// a frame *under* its own bg-card tiles.
export function nodeTypeSurface(
  hue: string,
  options: { mix?: number; borderMix?: number; ground?: string } = {},
): CSSProperties {
  const { mix = 12, borderMix = 30, ground = 'hsl(var(--card))' } = options;
  return {
    color: `color-mix(in srgb, ${hue} 70%, hsl(var(--foreground)))`,
    background: `color-mix(in srgb, ${hue} ${mix}%, ${ground})`,
    borderColor: `color-mix(in srgb, ${hue} ${borderMix}%, transparent)`,
  };
}
